export const useGetCartID = () => {
  return window.localStorage.getItem('cartID')
}
